var map = {
	"./accordion/accordion-item.vue": 99,
	"./accordion/accordion.vue": 100,
	"./accordion/declarations-accordion-content-cmp.vue": 953,
	"./accordion/distributors-accordion-content-cmp.vue": 954,
	"./atoms/accordion-link.vue": 234,
	"./atoms/btn.vue": 102,
	"./atoms/checkbox.vue": 235,
	"./atoms/icon-link.vue": 21,
	"./atoms/icon.vue": 6,
	"./atoms/js-loader.vue": 955,
	"./atoms/responsive-img.vue": 103,
	"./atoms/spinner.vue": 236,
	"./base-footer.vue": 956,
	"./base-header.vue": 957,
	"./carousel/carousel-item.vue": 239,
	"./carousel/carousel.vue": 240,
	"./excerpt-card.vue": 241,
	"./faq.vue": 950,
	"./figure-widget.vue": 958,
	"./free-search.vue": 238,
	"./good-for-you-product.vue": 959,
	"./google-map.vue": 951,
	"./hero-content.vue": 960,
	"./image-box.vue": 243,
	"./languages.vue": 104,
	"./layout/accessible-dialog.vue": 244,
	"./layout/aspect-ratio-box.vue": 105,
	"./layout/blank-space.vue": 961,
	"./layout/container.vue": 39,
	"./layout/featuring-grid.vue": 962,
	"./layout/flex-col.vue": 245,
	"./layout/flex-grid.vue": 246,
	"./layout/layered-background.vue": 963,
	"./layout/postit-on-image.vue": 964,
	"./layout/row-col-responsive-cmp.vue": 101,
	"./layout/separator.vue": 49,
	"./layout/side-by-side.vue": 965,
	"./layout/slot-wrapper.vue": 50,
	"./media-downloader.vue": 952,
	"./news-article.vue": 966,
	"./page-header.vue": 967,
	"./pagination.vue": 248,
	"./people-info.vue": 968,
	"./perspective-2030-item.vue": 249,
	"./perspective-2030.vue": 969,
	"./picture-preview-box.vue": 250,
	"./position-box.vue": 970,
	"./preloader.vue": 971,
	"./quote-box.vue": 972,
	"./search-box.vue": 251,
	"./search-interface.vue": 973,
	"./search-item.vue": 974,
	"./share-bar.vue": 247,
	"./sided-title-text.vue": 975,
	"./skip-to-content.vue": 976,
	"./slide-box.vue": 977,
	"./social-card.vue": 978,
	"./socials.vue": 237,
	"./tabs/tabs.vue": 242,
	"./templates/multimedia-box/multimedia-box.vue": 107,
	"./title-text.vue": 979,
	"./video-box.vue": 106,
	"./video-inline.vue": 980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;